<template>
  <div>
    <van-field :label="labelData" :rules="[{required:false}]">
        <template #input>
            <van-uploader :readonly="readonly" :disabled="disabled" :deletable="!(readonly||disabled)"
            :show-upload="!(readonly||disabled)" multiple :max-count="maxCount" :after-read="save" v-model="files"
            :before-delete="deleteFile" :before-read="beforeRead" :accept="accept" :preview-full-image="fullImg"
            :preview-options="{closeable:true}"
            @click-preview="$emit('imgView',true)"
            @close-preview="$emit('imgView',false)"/>
        </template>
    </van-field>
  </div>
</template>
<script>
import Config from "@/components/Config.vue";
import DateUtils from "@/plugins/DateUtils.vue";
export default {
  data() {
    return {
      labelData:'上传文件',
      files:[],
      accept:'image/*,.gif,.avi,.mp4,.mp3,.wav,.rar,.zip,.tar,.gz,.7z,.bz2,.cab,.iso,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt,.md,.xml,.py,.msg',
      loading: false,
      uploadedFileList: [],
      uploadData: {
        tenant: "portal",
        name: "",
        description: ""
      },
      uploadUrl: Config.apiUrl + "/api/store/v0.1/upload/"
    };
  },
  props: {
    label:{
      type:String,
      default:'上传文件'
    },
    type:{
      type:String,
      default:'FILE'
    },
    maxCount:{
      type:Number,
      default:20
    },
    fileIds: {
      type: Array,
      default(){
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    fullImg: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    let label = this.label
    if(this.type == 'IMG'){
      this.accept = 'image/*'
      if(label=='上传文件'){
        label = '上传图片'
      }
    }
    this.labelData = label
  },
  watch:{
    fileIds:{
      immediate:true,
      handler(val,old){
        this.uploadedFileList = this.fileIds
        this.initUpdateFileList()
      }
    }
  },
  methods: {
    save(file,detail){
      file.status = 'uploading'
      file.message=this.$t('scz')
      let formData = new  FormData()
      formData.append('file',file.file)
      formData.append('tenant','portal')
      formData.append('name',file.file.name)
      formData.append('description','')
      this.$http.post('/api/store/v0.1/upload',formData,{'Content-Type':'multipart/form-data'})
      .then(res=>{
        if(res.data.errcode == 0 && res.data.data.guid){
          this.uploadedFileList.push(res.data.data.guid)
          this.$message.success(file.file.name + this.$t('shangchuanchenggong'));
          file.status = 'down'
          file.message = undefined
          this.change()
        }else{
          file.status = 'failed'
					file.message = this.$t('scsb')
          this.uploadFail(file.file.name,detail,res.data.errmsg)
        }
      }).catch(err=>{
        file.status = 'failed'
        file.message = this.$t('scsb')
        this.uploadFail(file.file.name,detail)
      })
    },
    uploadFail(name,detail,msg){
			this.files.splice(detail.index,1)
			msg = msg?`;err:${msg}`:''
      this.$message.error(this.$t('wj')+name+this.$t('scsb')+msg);
    },
    beforeRead(file){
      if("IMG"==this.type){
        if(!file.type.startsWith('image')){
          this.$message.error(this.$t('qsctpgswj'));
          return false
        }
      }
      return true
    },
    deleteFile(file,detail){
      this.Dialog.confirm({
        title:this.$t('jg'),
        message:this.$t('scwj')
      }).then(()=>{
        this.$http
        .post("/api/store/v0.1/delete", "tenant=portal&guid=" + this.uploadedFileList[detail.index])
        .then(res => {
          var js = res.data;
          if (js.errcode == 0) {
            this.files.splice(detail.index,1)
            this.uploadedFileList.splice(detail.index,1)
            this.$message.success(file.name + this.$t('shanchuchenggong'));
            this.change()
          } else {
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error"
            });
          }
        });
        
      }).catch(()=>{
        
      })
      // debugger
    },
    
    //File getList
    initUpdateFileList() {
      console.log(this.fileIds,this.uploadedFileList)
      if (this.uploadedFileList.length == 0){
        this.files = []
        this.uploadedFileList = []
        return false;
      }
      // this.fileIds.forEach(item=>{
      //   this.files.push({url:this.Config.apiUrl + "/api/store/v0.1/read/"+item,isImage:false})
      // })
      this.$http
        .get("/api/store/v0.1/getUploadList", {
          params: {
            tenant: "portal",
            fileIds: this.uploadedFileList.join(",")
          }
        })
        .then(res => {
          if(res.data.data){
            let f = []
            let u = []
            res.data.data.forEach(item=>{
              u.push(item.guid)
              let isImg = this.type=='IMG'||('.jpeg,.jpg,.png,.PNG,.JPG'.indexOf(item.fileType)>-1)
              f.push({text:'123',name:'123',message:item.guid,url:this.Cookie.get('apiUrl')+ "/api/store/v0.1/read/"+item.guid,isImage:isImg})
            })
            this.files = f
            this.uploadedFileList = u
            this.change()
          }
        })
    },
    change(){
      let eq = true
      if(this.fileIds.length == this.uploadedFileList.length){
        this.fileIds.forEach((item,index)=>{
          if(this.uploadedFileList[index] != item){
            eq = false
          }
        })
      }else{
        eq = false
      }
      
      console.log(eq,JSON.stringify(this.uploadedFileList),JSON.stringify(this.fileIds))
      // alert(JSON.stringify())
      if(!eq){
        this.$emit('fileChange',this.uploadedFileList)
      }
    }
  }
};
</script>